<template>
  <div class="rooot">
      查看详情
  </div>
</template>

<script>
export default {

}
</script>

<style>

</style>